import React from 'react';
import './ContactUs.css';

const ContactUs: React.FC = () => {
  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>Contact Us</h1>
        <p>If you have any questions, feedback, or inquiries, feel free to reach out to us using the form below or email us directly at <a href="mailto:support@smartrainmakers.com">support@smartrainmakers.com</a>.</p>
        <p>You can reach us directly via email at <a href="mailto:support@smartrainmakers.com">support@smartrainmakers.com</a>. Our team is here to help you with any questions or concerns.</p>
        <p>For business collaborations, press inquiries, or partnership opportunities, please don’t hesitate to get in touch. We’re excited to hear from like-minded communities and innovators who share our mission.</p>
        <p>Our support team typically responds within 24–48 hours. Thank you for being a part of the Smart Rainmakers community.</p>
      </div>
    </div>
  );
};

export default ContactUs;
